/** @jsx jsx */
import React, {useState, useEffect} from 'react';
import { css, jsx } from '@emotion/core';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { productColor } from 'components/styles';
import BodyText from "components/atoms/BodyText";
import { MenuItem } from 'components/templates/menuData';
import Icon from 'components/atoms/Icon';
import { useHistory, useLocation } from 'react-router-dom';

const style = {
  boxItem: css({
    padding: "10px 29px", 
    color: "#999999", 
    fontSize: "12px",
    "&:hover": {
      background: "#E7F1FD",
      color: productColor.primary,
      cursor: "pointer"
    }
  }),
  boxSubItem: css({
    cursor: "pointer",
    justifyContent: 'space-between',
    padding: '5px',
    '&:hover': {
      background: '#e7f1fd'
    }
  }),
  subMenuLevel1: css({
    padding: "10px", 
    cursor: "pointer"
  }),
  activeItem: css({
    background: "#E7F1FD",
    color: productColor.primary,
    cursor: "pointer"
  }),
  boxSubMenu: css({
    overflow: 'hidden',
    maxHeight: '1000px',
    transition: 'max-height 1.2s linear'
  })
};

const BoxMenuLeft: React.FC<{
  display: string,
  value: string,
  subMenu?: any,
  level: number,
  portal?: boolean
}> = ({ display, value, subMenu, level, portal }) => {
  const history = useHistory();

  const location = useLocation();
  let group = location.pathname.split('/')[1];
  let group_2 = location.pathname.split('/')[2];

  const [stateClickItem, setStateClickItem] = useState(false);

  useEffect(() => {
    let newGroup = "";
    if(group === 'recorder'){
      newGroup = group_2
    }else{
      newGroup = group
    }
    setStateClickItem(newGroup === value || (subMenu && subMenu.filter((item: any) => item.value === newGroup).length > 0));
  }, [location]);
  
  const handClick = () => {
    setStateClickItem(!stateClickItem);
    
    if(!subMenu) {
      history.push(`${value === 'id' || value === 'face' || value === 'gps' ? '/recorder/' + value : '/' + value}`);
    }
  };

  let listSubMenu =  subMenu && subMenu.map((subMenu: MenuItem, index: number) => {
    return (
      <BoxMenuLeft
        display={subMenu.display}
        value={subMenu.value}
        subMenu={subMenu.subMenu}
        level = {level + 1}
      />
    );
  });

  return(
    <div>
      <FlexBox
        onClick={handClick} 
        customStyle={
          css([
            style.boxSubItem, 
            (stateClickItem && !subMenu) ? {background: '#e7f1fd'} : {}
          ])
        } 
      >
        <FlexBoxItem customStyle={css({ textIndent: `${portal ? level * 10 : level * 20}px` })}> 
          <BodyText 
            color="#666666" 
            customStyle={css({whiteSpace: 'nowrap'})}
          >
            {display}
          </BodyText>
        </FlexBoxItem>
        {
          subMenu && subMenu.length > 0 && (
            <FlexBoxItem 
              customStyle={
                css([
                  {transition: '0.5s'},
                  stateClickItem ? {transform: 'rotate(90deg)'} : {}
                ])
              }
            >
              <Icon 
                type={"chevronMenu"}
                color={productColor.primary} 
                size="12px" 
                verticalAlign="middle" 
              />
            </FlexBoxItem>
          )
        }
      </FlexBox>
      <div 
        css={
          css([
            style.boxSubMenu, 
            stateClickItem ? {} : {maxHeight: '0', transition: 'max-height 0.5s linear'}
          ])
        }
      >
        {listSubMenu}
      </div>
    </div>
  );
};

export default BoxMenuLeft;
